import { inject, Injectable } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { ErrorService } from "src/app/common/services/error.service";

@Injectable({
  providedIn: "root",
})
export class NotificationService {
  private readonly errorService = inject(ErrorService);
  private readonly toastrService = inject(ToastrService);

  showError(err: unknown, message: string): void {
    if (err) {
      console.error(err);
      const error = err as { message?: string; stack?: string };
      this.errorService.sendError(error.stack || error.message || JSON.stringify(error));
    }
    this.toastrService.error(`${message}, l'équipe technique a été notifiée.`, "Erreur");
  }

  showInfo(message: string): void {
    this.toastrService.info(message, "Info");
  }

  showWarning(message: string): void {
    this.toastrService.warning(message, $localize`:@@notification_service_warning:Avertissement`);
  }
}
